ews.components.header.overlay = ews.components.header.overlay || {}

ews.components.header.overlay.mobile = function() {
	var $mobileMenu = $(".mobileMenu"),
		$overlay = $('.overlay'),
		$menu = $('.callMenus'),
		menuHtml = '',
		lastPos = 0,
		menuData = [];

	function init() {
		
		if (_isSetupComplete()) return; //already has been executed

		var megaNavTabCounter = 0;
		menuData = ews.components.header.meganav.getMenuData();

		menuData.forEach(function(item,index) {
			var source = $('<div>' + item.data + '</div>'),
				categorySubData = _sortCategorySubData(source.find('.subCatHldr'));

			megaNavTabCounter = megaNavTabCounter +1;

			_createMobileMenus(item, categorySubData, megaNavTabCounter);
		});
		$mobileMenu.find('ul.primaryMenu').html(menuHtml);
		$mobileMenu.find('.menuContent').append(_getCta());
	}

	function open() {
		lastPos = $(document).scrollTop();
		$overlay.removeClass('hide');
	 	$overlay.addClass('overlay--menu');
	 	$mobileMenu.addClass('open');
		$menu.addClass('active');

		$(document.documentElement).addClass('noScroll header-active');
	}

	function close() {
		$menu.removeClass('active');
		$mobileMenu.removeClass('open');
		$overlay.addClass('hide');
		$overlay.removeClass('overlay--menu');
		$(document.documentElement).removeClass('noScroll header-active');

		window.scrollTo(0, lastPos);
	}

	function toggle() {
		if (isOpen()) {
			close();
		} else {
			open();
		}
	}

	function _isSetupComplete() {
		return (menuData.length > 0);
	}

	function isOpen() {
		return ($mobileMenu.hasClass('open'));
	}

	function isActive($item) {
		return ($item.hasClass('active') && !$item.find('.active').length);
	}

	function setLevel(level) {
		clearLevel();
		$mobileMenu.addClass('level-'+level);
	}

	function clearLevel() {
		$mobileMenu.removeClass('level-1 level-2');
	}

	function _createMobileMenus(item, categorySubData, indx){

		var $source = $(item.data);

		var categoryHeading = item.$category.find('a').text(),
			categoryLink = item.$category.find('a').attr('href') || '#',
			hasChildLinks = (categorySubData.length > 0) ? true : false,
			$promo = $source.find('.menu-nav-image-link'),
			style = '';

		categoryLink = categoryLink == '#' ? '' : categoryLink;

		if (!hasChildLinks) style = 'style="'+item.$category.attr('style')+'"' || '';
		

		menuHtml += '<li class="'+getChildLinkClass(hasChildLinks)+'"><a href="'+categoryLink+'" ';
		if (categoryLink) menuHtml += 'data-href="'+categoryLink+'"';
		menuHtml +=  style + ' >' + categoryHeading + '</a>';

		if (hasChildLinks) {
			menuHtml += '<ul class="firstLMenu menuWrap" data-event-name="primaryNavigation" data-element-channel="ews.headerFooter" data-event="click" data-event-params="">';
			$(categorySubData).each(function(subIndx){
				var categorySubHeading = $(this).find('h2').text(),
					categorySubLink = $(this).find('h2 a').attr('href') || '#',
					$list = $(this).find('ul li'),
					hasChildLinks = ($list.length > 0)  ? true : false;

                menuHtml += '<li class="'+getChildLinkClass(hasChildLinks)+'"><a href="'+categorySubLink+'"';
                if (categorySubLink) menuHtml += 'data-href="'+categorySubLink+'"';

                menuHtml += '>' + categorySubHeading + '</a>';

                if (hasChildLinks) {
	                menuHtml +=  '<ul class="secondLMenu menuWrap" data-event-name="secondaryNavigation" data-element-channel="ews.headerFooter" data-event="click" data-event-params="">';
					$list.each(function(){
						var categorySubLinks = $(this).html();
						menuHtml +='<li>' + categorySubLinks + '</li>';
					});
					menuHtml +='</ul>'; //end .secondLMenu                	
                }

				menuHtml +='</li>'; //end .secondLMenu
			});
			if ($promo.length) menuHtml += _getPromoHtml($promo);
			menuHtml +='</ul>';
		}

		menuHtml += '</li>';

		return menuHtml;
	}// end _createMobileMenus

	function _getPromoHtml($source) {
		var link = $source.find('a').attr('href');
			html = '<li class="promo">';

		if (link) html += '<a href="'+link+'">';
		html += $source.find('img').prop('outerHTML');
		if (link) html += '</a>';
		html += '</li>';

		return html;
	}

	function getChildLinkClass(hasChildLinks) {
		return hasChildLinks ? 'has-childlinks' : '';
	}

	function getDirectLinkClass(url) {
		return url ? 'direct-link' : '';
	}

	function _sortCategorySubData(subData) {
		/*  Required to sort the menu items for mobile menu construction
		*  the subData list needs to be ordered from left to right by row for mobile
		*/
		var subDataArray = subData;
		var sortedDataArray = [];
		try {
		// for each menu item check its position in its parent column
		// we want to add item i from each column
		for(i = 0; i < subDataArray.length; i++) {
			$(subDataArray).each( function() {
				if( $($(this).parent().children()).index(this) === i &&
					$(this).hasClass('subCatHldr') ) {
					sortedDataArray.push($(this));
				}
			});
		}

		} catch (e) {
			// if there is an error then return the unsorted array
			sortedDataArray = subDataArray;
		} finally {
			return sortedDataArray;
		}
	}

	function _getCta() {
		return $('.header .cta')[0].outerHTML;
	}

	return {
		init: init,
		open: open,
		close:  close,
		toggle: toggle,
		isOpen: isOpen,
		isActive: isActive,
		setLevel: setLevel,
	    clearLevel: clearLevel
    };
}();
